<template>
  <div class="pages">
    <div :class="{ isFixed: searchBarFixed }">
      <div class="top facab">
        <div class="fac d-guide">
          <span style="cursor: pointer;" @click="handleNavigation"> {{ $t('main.productCenter') }}</span>
          <i class="el-icon-arrow-right"></i>
          <span style="cursor: pointer;" @click="handleNavigation(productId)">{{ productTitle }}</span>
          <i class="el-icon-arrow-right"></i>
          <span> {{  nowProductName }}</span>
        </div>
        <div class="fac">
          <div style="cursor: pointer;font-size: 1.1428rem;" @click="gotomyorder">{{ $t('main.myOrder') }}（ {{allTotal}} ）</div>
        </div>
      </div>
      <div id="process" class="process">
        <div class="product_title">{{ productTitle }}</div>
        <div
          v-for="(item, index) in list"
          :key="index"
          class="step"
          :class="{ isActived: actived === item.id }"
          @click="handleChangeProduct(item)"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div
        class="pBox"
        v-for="(itm, ind) in childrenList"
        :key="ind"
        @click="handleDetail(itm)"
      >
        <img v-if="itm.image" :src="itm.image" class="pImg img_replace" />
        <div v-else class="pImg img_replace"> {{ $t('main.nopic') }}</div>
        <div class="pText nowap">{{ itm.name }}</div>
        <div class="pPrice">{{ itm.price }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { listOrder } from '@/api/order'
import { getProductTypeNavList,getProductInfo } from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      steps: [],
      site_id: 1,
      list: [],
      childrenList: [],
      searchBarFixed: false,
      actived: 0,
      searchParam: "",
      allTotal: "0", // 我的订单总数
      productId: "",
      productTitle: "",
      nowProductIndex:"0",
      nowProductName:"",
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },

  computed: {
    routeHistory() {
      return this.$store.state.routeHistory;
    }
  },
  watch: {
    "$store.state.siteInfo": function(newV) {
      if (newV) {
        this.site_id = newV;
      }
      this.init();
    },
    "$store.state.tabs": function() {
      this.init();
    }
  },
  mounted() {
    this.init();
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    init() {
      if (localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))) {
        this.steps = this.treeToArray(JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))));
        let nowProductType = this.steps.find(item => {
          if (item.identification) {
            return this.$route.params.identification == item.identification;
          } else {
            return this.$route.params.identification == item.id;
          }
        });

        if (nowProductType) {
          let params = {
            req: {
              page: 1,
              limit: 10000,
              order: "orderby asc",
              where: [
                {
                  condition: nowProductType.id,
                  filed: "pid",
                  expression: "="
                },
                {
                  condition: "1",
                  filed: "status",
                  expression: "="
                }
              ]
            }
          };
          getProductTypeNavList(params).then(res => {
            if(res.rsp.code === 0) {
              this.childrenList = res.data.list;
            } else {
              this.$message({
                message: res.rsp.msg,
                type: "error",
              });
            }
          });

          if(this.steps.length) {
            let target = this.steps.find(item => item.id == nowProductType.id);
            this.list = this.steps.filter(item => target.pid === item.pid);
            this.$nextTick(() => {
              this.actived = nowProductType.id;
              this.productTitle = this.steps.filter(item => target.pid == item.id)[0].name;
              this.productId = this.steps.filter(item => target.pid == item.id)[0].id;
              this.nowProductName = this.list.filter(item => item.id == nowProductType.id)[0].name;
            });
          }
          this.getOrderCount();
        }
      }
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    handleNavigation(id) {
      if(typeof id !== "string") {
        this.$router.push({
          path: "/product"
        });
      } else {
        let params = {
          req: {
            id: id
          }
        };
        getProductInfo(params).then(res => {
          if(res.rsp.code === 0) {
            const item = res.data;
            this.$router.push({
              path: this.getRoutesPath('category_product', item['identification'], item['id'])
            });
          } else {
            this.$message({
              message: res.rsp.msg,
              type: "error",
            });
          }
        });
      }
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    // 跳转到个人中心-我的订单
    gotomyorder() {
      this.$router.push({ path: "/userCenter"});
    },
    // 获取我的订单数量
    getOrderCount(){
      const orderListParams = {
        req: {
          page: 1,
          limit: 1000,
          where: [
            {
              condition: "8",
              filed: "status",
              expression: "<>"
            },
            {
              condition: this.site_id.toString(),
              filed: "site_id",
              expression: "="
            }
          ],
          order: 'id desc',
        },
      }
      listOrder(orderListParams).then((res) => {
        if (res.rsp.code === 0) {
          // 删选掉已删除的订单
          this.allTotal = res.data.total;
        }
      })
    },
    handleChangeProduct(item) {
      this.$router.push({
        path: this.getRoutesPath(item['list_template'], item['identification'], item['id'])
      });
    },
    handleDetail(item) {
      this.$router.push({
        path: this.getRoutesPath('detail_product', item['identification'], item['id'])
      });
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 60) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;
  .d-guide {
    height: 6rem;
    line-height: 6rem;
    color: #999999;
  }

  .isFixed {
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100%;
    background-color: #fff;
    padding-bottom: 1.25rem;
  }
  .top {
    height: 6rem;
    line-height: 6rem;
  }
  .process {
    height: 30px;
    line-height: 30px;
    background-color: #f2f2f2;

    .product_title {
      font-size: 1.1428rem;
      font-weight: bold;
      padding-right: 4rem;
      float: left;
    }

    .step {
      font-size: 1.1428rem;
      color: #FFF;
      float: left;
      padding: 0 20px;
      margin: 0 20px 0 0;
      min-width: 100px;
      text-align: center;
      border-radius: 0.2rem;
      cursor: pointer;
      position: relative;
      background: #B8B0D4;
      &:hover {
        background: #635796;
        color: #FFF;

        &:before {
          content: '';
          position: absolute;
          bottom: -5px;
          left: calc(50% - 2.5px);
          width: 10px;
          height: 10px;
          background: #635796;
          transform: rotate(45deg);
        }
      }
      &:not(:last-child):after {
        content: '';
        float: right;
        width: 2px;
        height: 20px;
        background: #635796;
        right: -10px;
        top: 5px;
        position: absolute;
      }
    }

    .isActived {
      background: #635796;

      &:before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: calc(50% - 2.5px);
        width: 10px;
        height: 10px;
        background: #635796;
        transform: rotate(45deg);
      }
    }
  }
  .content {
    .pBox {
      width: calc(25% - 2rem);
      //height: 17.5rem;
      margin: 1rem 1rem;
      display: inline-block;
      .pImg {
        width: 100%;
        //height: 13.125rem;
        border-radius: 1rem;
        min-height: 110px;
      }
      .img_replace {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px dashed #666666;
        cursor: pointer;
      }
      .pText {
        color: #1a1a1a;
        margin-top: 1.25rem;
        text-align: center;
        cursor: pointer;
      }
      .pPrice {
        font-weight: bold;
        color: #cd3222;
        margin-top: 1.125rem;
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .top,
    .process {
      padding: 0 2%;
    }
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .top,
    .process{
      padding: 0 10%;
    }
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .top,
    .process{
      padding: 0 15%;
    }
    .content {
      padding: 0 15% 3.25rem;
    }
  }
}
</style>
